import type React from "react";
import {IconButton, Tooltip} from "@mui/material";
import HelpIcon from "~/icons/svg/HelpIcon.svg?react";

/**
 * A help icon whose content shows in the design's tooltip on hover (or focus, or a long press on touch). The tooltip
 * is interactive: it stays while the mouse moves into it, so its text can be read and selected.
 */
export const HelpComponent: React.FC<{
    helpContent: React.ReactNode;
}> = ({helpContent}) => (
    <Tooltip
        title={helpContent}
        placement="bottom"
        arrow
        leaveDelay={150}
        // Screen readers announce the help text as the icon's description (its name stays "Help").
        describeChild
    >
        <IconButton aria-label="Help">
            <HelpIcon width={20} height={20}/>
        </IconButton>
    </Tooltip>
);
